import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-record',
  templateUrl: './land-record.component.html',
  styleUrls: ['./land-record.component.css']
})
export class LandRecordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/land-record/land-record.component.ts